import { render, staticRenderFns } from "./MenuCard.vue?vue&type=template&id=33c0d776&scoped=true"
import script from "./MenuCard.vue?vue&type=script&lang=js"
export * from "./MenuCard.vue?vue&type=script&lang=js"
import style0 from "./MenuCard.vue?vue&type=style&index=0&id=33c0d776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c0d776",
  null
  
)

export default component.exports